import React, { useState, useRef, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

import {
  Switch,
  Checkbox,
  InputNumber,
  Flex,
  Row,
  Col,
  Button,
  Form,
  Input,
  Drawer,
  message,
  Watermark,
  Space,
  Divider,
  Card,
  Dropdown,
} from "antd";
import {
  SearchOutlined,
  UserOutlined,
  SmileOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { PrinterOutlined, BarsOutlined } from "@ant-design/icons";
import { LayoutData } from "../Structur/Aconlayout";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useDebounce } from "../Helper/hocks.ts";
import { AconKundenListe } from "./AconKundenListe";
import { AconkundenDetails } from "./AconkundenDetails.jsx";
import { EvidenzDatenEmails } from "./EvidenzDatenEmails.jsx";

export const Aconkunden = () => {
  const {
    checkRole,
    checkRoles,
    setCookie,
    getCookie,
    eventDataPost,
    eventDataDelete, 
    getApiBaseUrl,
    apiBaseUrl,
    aktPdfDaten,
    setAktPdfDaten,
    checkMainContainerHeight,
  } = LayoutData();
  const { user, userDaten, windowWidth, aktSumsComponent, logoutLogin } =
    LayoutData();
  const [url1, setUrl1] = useState();
  const [suchbegriff, setSuchbegriff] = useState("");
  const debouncedSuchbegriff = useDebounce(suchbegriff);
  const [dataSource, setDataSource] = useState();

  const [showDrawer1, setShowDrawer1] = useState();
  const [editDrawerCaption1, setEditDrawerCaption1] = useState();
  const [showDrawer2, setShowDrawer2] = useState();
  const [editDrawerCaption2, setEditDrawerCaption2] = useState();
  const [showProfiAuswahl, setShowProfiAuswahl] = useState(false);
  const [aktRecnr, setAktRecnr] = useState(0);
  const [aktEvadrRecNr, setAktEvadrRecNr] = useState(0);
  const [headName,setHeadName]=useState();


  useEffect(() => {
    aktSumsComponent(<>Aconsoft Kunden mit ACON Klassik {apiBaseUrl} </>);
    //if (isNaN(tableArt)) setTableArt(1);
  }, []);

  // Es muss immer ein BaseUrl geben
  useEffect(() => {
    if (apiBaseUrl && debouncedSuchbegriff !== "") {
      setUrl1(
        `${apiBaseUrl}api/evliveup?secure=1d7b2028-cee4-4589-8be0-fdd2d1cca996&Suchbegriff=${debouncedSuchbegriff}`
      );
    }
  }, [apiBaseUrl, debouncedSuchbegriff]);

  const {
    isPending: isPending1,
    error: error1,
    data: aconkundenData,
  } = useQuery({
    queryKey: [url1],
    queryFn: () => {
      if (url1) {
        // Überprüfen, ob url1 definiert ist
        return fetch(url1, {
          headers: {
            Authorization: `Bearer ${user.bearer}`,
          },
        }).then((res) => {
          if (res.status === 401) logoutLogin();
          if (!res.ok) {
            throw new Error('XXX Network response was not ok');
          }
          return res.json();
        })
        .catch((error) => {
          console.error('XXX Error fetching data:', error);
          // Hier kannst du entscheiden, wie du mit dem Fehler umgehen möchtest
          throw error; // Reicht den Fehler weiter, damit er von der aufrufenden Funktion behandelt werden kann
        });
      } else {
        // Wenn url1 nicht definiert ist, gib ein leeres Objekt zurück oder handle den Fall entsprechend
        console.log("XXX Kein url1 definiert", url1);
        return []; // Promise.resolve({});
      }
    },
  });

  if (error1) {
    //console.log("url1", url1);
    console.error("XXX Error", error1);
  }

  useEffect(() => {
    if (aconkundenData && Array.isArray(aconkundenData)) {
      // console.log("XXX aconkundenData", aconkundenData);
      const newData = aconkundenData.map((item, index) => ({
        ...item,
        key: index,
      }));
      aktSumsComponent(
        <Flex wrap gap={"small"} style={{ overflow: "auto" }}>
          <div>{newData.length} Datensätze gefunden</div>
        </Flex>
      );
      //checkMainContainerHeight();
      setDataSource(newData);
    } else setDataSource([]);
  }, [aconkundenData]);

  const onSuchbegriffChanged = (e) => {
    // console.log(e.target.value);
    setSuchbegriff(e.target.value);
  };
  const tableTitle = () => {
    return (
      <Space direction="vertical">
        <Form
          layout="horizontal"
          //onFinish={onSuchbegriffFinish}
          // initialValues={{ suchbegriff: this.state.suchbegriff }}
        >
          <Row gutter={1}>
            <Col span={24}>
              <Form.Item
                label="Suchbegriff:"
                name="suchbegriff"
                rules={[
                  {
                    required: true,
                    message: "Bitte geben Sie mindestens einen Buchstaben ein!",
                  },
                ]}
              >
                <Input
                  placeholder="Suchbegriff für Kundensuche"
                  //required
                  prefix={<SearchOutlined />}
                  onChange={onSuchbegriffChanged}
                ></Input>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Space>
    );
  };
  const handleOnDetailClick = (daten) => {
    //console.log("XXX ",daten);
    setAktRecnr(daten.recNr);
    setShowDrawer1(true);
  };
  const handleOnEMailsClick = (daten) => {
    //console.log("XXX ",daten);
    setAktEvadrRecNr(daten.evAdrRecNr);
    setHeadName(daten.name);
    setShowDrawer2(true);
  }; 
  return ( 
    <>
      <div className="page">
        <AconKundenListe
          title={tableTitle}
          dataSource={dataSource}
          loading={isPending1}
          handleOnDetailClick={handleOnDetailClick}
          handleOnEMailsClick={handleOnEMailsClick}
        />
      </div>
      <Drawer
        destroyOnClose
        open={showDrawer1}
        title={editDrawerCaption1 && editDrawerCaption1}
        onClose={() => setShowDrawer1(false)}
        loading={false}
        width={400}
      >
        <AconkundenDetails
          aktRecnr={aktRecnr}
          setTitel={setEditDrawerCaption1}
        />
      </Drawer>
      <Drawer
        destroyOnClose
        open={showDrawer2}
        title={editDrawerCaption2 && editDrawerCaption2}
        onClose={() => setShowDrawer2(false)}
        placement="left"
        loading={false}
        width={400}
        //style={{ background: '#f0f0f0', padding: '2px' }} //
      >

        <EvidenzDatenEmails
         aktEvadrRecNr={aktEvadrRecNr}
         setTitel={setEditDrawerCaption2}
         headName={headName}
            gruppe={1}
        
        />
       
      </Drawer>
    </>
  );
};
